import Vue from "vue";
import Vuex from "vuex";
import jwtDecode from "jwt-decode";
import isAdmin from "../util/isAdmin";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    username: "",
    userId: undefined,
    isAdmin: false,
    notifications: 0,

    snackbar: {
      visible: false,
      text: "",
      timeout: 3000,
      icon: "mdi-alert-rhombus",
      iconColor: "success",
      multiline: false,
    },

    reportPopup: {
      visible: false,
      contentId: undefined,
      contentType: "",
    },

    drawer: {
      visible: false,
      status: "",
      data: {},
    },

    search: {
      query: "",
      category: "",
      results: [],
      scrollY: 0,
    },

    homePage: {
      results: [],
      scrollY: 0,
      reviewSetIdx: 0,
      endOfReviews: false,
    },
  },
  mutations: {
    logout(state) {
      state.username = "";
      state.userId = undefined;
      state.isAdmin = false;
      state.notifications = 0;

      state.homePage = {
        results: [],
        scrollY: 0,
        reviewSetIdx: 0,
        endOfReviews: false,
      };

      return "Logged Out";
    },
    async login(state, payload) {
      let decoded;
      try {
        decoded = jwtDecode(payload.authorization);
      } catch (err) {
        return err;
      }
      state.username = decoded.username;
      state.userId = decoded.userId;
      state.isAdmin = await isAdmin(state.userId);
    },

    /*
            Notifications
        */
    setNotifications(state, payload) {
      if (!isNaN(parseInt(payload.count))) {
        state.notifications = parseInt(payload.count);
        return "Notifications set";
      } else {
        return new Error("Count not valid");
      }
    },
    decrementNotifications(state) {
      if (state.notifications > 0) {
        state.notifications -= 1;
      }
    },

    /*
            Snackbar
        */
    showSnackbar(state, payload) {
      state.snackbar.text = payload.text;
      state.snackbar.multiline = payload.text.length > 50;

      if (payload.multiline) {
        state.snackbar.multiline = payload.multiline;
      }

      if (payload.timeout) {
        state.snackbar.timeout = payload.timeout;
      }

      if (payload.error) {
        state.snackbar.iconColor = "error";
        state.snackbar.icon = "mdi-alert-rhombus";
      } else {
        state.snackbar.iconColor = "success";
        state.snackbar.icon = "mdi-check-circle";
      }

      state.snackbar.visible = true;
    },

    closeSnackbar(state) {
      state.snackbar.visible = false;
      state.snackbar.multiline = false;
      state.snackbar.timeout = 3000;
      state.snackbar.text = null;
    },

    showReportPopup(state, payload) {
      state.reportPopup.visible = true;
      state.reportPopup.contentId = payload.contentId;
      state.reportPopup.contentType = payload.contentType;
    },

    closeReportPopup(state) {
      state.reportPopup.visible = false;
      state.reportPopup.contentId = undefined;
    },

    /*
            Review Drawer
         */
    showDrawer(state, payload) {
      state.drawer.visible = true;
      state.drawer.status = payload.status;
      state.drawer.data = payload.data;
    },

    closeDrawer(state) {
      state.drawer.visible = false;
    },

    /*
            Persistent State Search
         */
    saveSearch(state, payload) {
      state.search.query = payload.query;
      state.search.results = payload.results;
      state.search.category = payload.category;
      state.search.scrollY = payload.scrollY;
    },

    saveHomePage(state, payload) {
      state.homePage.results = payload.results;
      state.homePage.scrollY = payload.scrollY;
      state.homePage.reviewSetIdx = payload.reviewSetIdx;
      state.homePage.endOfReviews = payload.endOfReviews;
    },

    updateSavedForLater(state, payload) {
      if (state.search.category === payload.medium) {
        state.search.results.forEach((item) => {
          if (item.id === payload.internal_id) {
            item.saved_for_later = payload.value;
          }
        });
      }
    },
    updateSeen(state, payload) {
      if (state.search.category === payload.medium) {
        state.search.results.forEach((item) => {
          if (item.id.toString() === payload.workId.toString()) {
            item.engaged = payload.value;
          }
        });
      }
    },
  },
});
